import { defineFormSchema } from '../../../shared/data/formSchema';
export const formSchema = defineFormSchema({
  "id": "suppliers.supplier.create",
  "fields": [
    { "name": "ownerName", "label": "Nome titolare", "type": "text" },
    { "name": "reaNumber", "label": "Numero REA", "type": "text" },
    { "name": "referredBy", "label": "Riferito da", "type": "text" },
    {
      "name": "legalName",
      "label": "Ragione Sociale",
      "type": "text"
    },
    {
      "name": "displayName",
      "label": "Nome visualizzato",
      "type": "text"
    },
    {
      "name": "category",
      "label": "Categoria",
      "type": "select",
      "options": ["Servizi", "Consulenza", "Tecnologia e informatica", "Logistica e trasporti", "Materiali e forniture", "Manutenzione", "Farmaci", "Altro"]
    },
    {
      "name": "sector",
      "label": "Settore",
      "type": "text"
    },
    {
      "name": "legalForm",
      "label": "Forma Giuridica",
      "type": "select",
      "options": ["S.r.l.", "S.p.A.", "S.a.s.", "S.n.c.", "Ditta Individuale", "Cooperativa", "Altro"]
    },
    {
      "name": "vatNumber",
      "label": "Partita IVA",
      "type": "text"
    },
    {
      "name": "taxCode",
      "label": "Codice Fiscale",
      "type": "text"
    },
    {
      "name": "status",
      "label": "Stato",
      "type": "select",
      "readOnly": true
    },
    {
      "name": "registeredAddress",
      "label": "Indirizzo Sede Legale",
      "type": "text"
    },
    {
      "name": "companyEmail",
      "label": "Email aziendale",
      "type": "email"
    },
    {
      "name": "companyPhone",
      "label": "Telefono aziendale",
      "type": "tel"
    },
    {
      "name": "contactName",
      "label": "Referente",
      "type": "text"
    },
    {
      "name": "contactRole",
      "label": "Ruolo referente",
      "type": "text"
    },
    {
      "name": "contactEmail",
      "label": "Email referente",
      "type": "email"
    },
    {
      "name": "contactPhone",
      "label": "Telefono referente",
      "type": "tel"
    },
    {
      "name": "notes",
      "label": "Nota",
      "type": "textarea"
    }
  ]
});
